import "./home.css"
import '@google/model-viewer'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

//Components
import Header from '../../components/Header'

// Images
import back from "../../assets/img/back.jpg"
import tuzzle_home from "../../assets/img/tuzzle_home.png"
import tuzzle_play from "../../assets/img/tuzzle_play.png"

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount = async () => {

    }

    render() {
        return (
            <div className="container" style={{ backgroundImage: `url('${back}')` }}>
                <div className="content">
                    <Header />
                    <div className="front">
                        <h1 className="title" style={{marginTop: "100px"}}>Development services</h1>
                        <div className="text">
                            <p>
                                Fullstack development
                            </p><p>
                                Let's get in touch : <a href="mailTo:contact@level426.xyz">contact@level426.xyz</a>
                            </p>
                            <hr />
                            <p>
                                <small>
                                    ©LEVEL426 2026. Simplified joint-stock company, registered B 920 591 021 to the RCS of Montpellier.
                                </small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Home)